module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/xbutton-c59ad883b59aa33a6d4bac8d3b9cf333.svg";